import React, { useContext } from "react";
import "./loader.css";
import { BrandColorContext } from "./App";

const LoaderInternal = () => {
  const brandColor = useContext(BrandColorContext);
  return (
    <div className="loader-internal-container flex-column">
      <svg
        className="spinning-wheel d-block "
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 122.88 122.88"
        style={{ enableBackground: "new 0 0 122.88 122.88" }}
        xmlSpace="preserve"
      >
        <g>
          <path
            fill={brandColor}
            d="M104.88,98.6c1.73,1.74,1.73,4.55,0,6.28c-1.74,1.74-4.55,1.74-6.28,0l-8.15-8.15c-6.82,5.61-15.29,9.28-24.57,10.18v11.52 c0,2.45-1.99,4.44-4.44,4.44c-2.45,0-4.44-1.99-4.44-4.44v-11.52c-9.28-0.9-17.75-4.57-24.57-10.18l-8.15,8.15 c-1.74,1.74-4.55,1.74-6.28,0c-1.74-1.73-1.74-4.55,0-6.28l8.15-8.15c-5.61-6.82-9.28-15.29-10.18-24.57H4.44 C1.99,65.88,0,63.89,0,61.44C0,58.99,1.99,57,4.44,57h11.52c0.9-9.28,4.57-17.75,10.18-24.57L18,24.28c-1.74-1.74-1.74-4.55,0-6.28 c1.73-1.74,4.55-1.74,6.28,0l8.15,8.15c6.82-5.61,15.29-9.28,24.57-10.18V4.44C57,1.99,58.99,0,61.44,0c2.45,0,4.44,1.99,4.44,4.44 v11.53c9.28,0.9,17.75,4.57,24.57,10.18L98.6,18c1.74-1.73,4.55-1.73,6.28,0c1.74,1.74,1.74,4.55,0,6.28l-8.15,8.15 c5.61,6.82,9.28,15.29,10.18,24.57h11.53c2.45,0,4.44,1.99,4.44,4.44c0,2.45-1.99,4.44-4.44,4.44h-11.53 c-0.9,9.28-4.57,17.75-10.18,24.57L104.88,98.6L104.88,98.6z M84.21,90.5L65.88,72.17v25.93C72.75,97.27,79.04,94.56,84.21,90.5 L84.21,90.5z M57,98.09V72.17L38.67,90.5C43.84,94.56,50.13,97.27,57,98.09L57,98.09z M32.38,84.21l18.33-18.33H24.79 C25.61,72.75,28.32,79.04,32.38,84.21L32.38,84.21z M24.79,57h25.92L32.38,38.67C28.32,43.84,25.61,50.13,24.79,57L24.79,57z M38.67,32.38L57,50.71V24.79C50.13,25.61,43.84,28.32,38.67,32.38L38.67,32.38z M65.88,24.79v25.92l18.33-18.33 C79.04,28.32,72.75,25.61,65.88,24.79L65.88,24.79z M90.5,38.67L72.17,57h25.92C97.27,50.13,94.56,43.84,90.5,38.67L90.5,38.67z M98.09,65.88H72.17L90.5,84.21C94.56,79.04,97.27,72.75,98.09,65.88L98.09,65.88z"
          />
        </g>
      </svg>
      <h5 className="text-main d-block my-5">
        Loading All Available Cruises Matches Your Search...
      </h5>
      {/* <p className="text-secondary  d-block">Loading...</p> */}
    </div>
  );
};

export default LoaderInternal;
